import React from "react";
import { CategoriesTable } from "./CategoriesTree";
import ActionHeader from "./ActionHeader/ActionHeader";
import useAxios from "axios-hooks";
import { Resource } from "../../api/common";
import { message } from "antd";

export const CategoriesViews = () => {
   const [{ data, loading, error }, refetch] = useAxios(
      Resource.path.getCategories
   );

   const [category, setCategory] = React.useState(null);

   const [
      { data: deleteData, loading: deleteLoading, error: deleteError },
      executeDelete
   ] = useAxios(
      {
         method: "delete"
      },
      { manual: true }
   );

   if (loading) return <p>Loading...</p>;
   if (error) return <p>Error! Please reload page</p>;

   const handleOnSubmitSuccess = () => {
      refetch();
   };

   const onDeleteItem = (categoryId: string) => {
      executeDelete({
         url: `${Resource.path.deleteCategories}/${categoryId}`
      }).then(() => {
         refetch();
         message.success("Categories deleted successfully.");
      });
   };

   const onCategoryEdit = (record: any) => {
      setCategory(record);
   };

   return (
      <>
         <ActionHeader
            onSubmitSuccess={handleOnSubmitSuccess}
            initialCategoriesData={category}
            onCategoryEdit={onCategoryEdit}></ActionHeader>
         <CategoriesTable
            onDeleteItem={onDeleteItem}
            onCategoryEdit={onCategoryEdit}
            data={data.data.data}
            loading={loading}
         />
      </>
   );
};
